var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QueryPage',{scopedSlots:_vm._u([{key:"default",fn:function({ entry }){return [_c('TemplateDetailPage',{attrs:{"entry":entry}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }